import React, { useEffect, useState } from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Home from "./Screens/Home/Home";
import Sidebar from "./Components/Sidebar/Sidebar";
import Setting from "./Screens/Setting/Setting";
import DashboardDashboardNavigation from "./Screens/Dashboard/DashboardNavigation";
import Calendar from "./Screens/Calendar/Calendar";
import Chat from "./Screens/Chat/Chat";
import Header from "./Components/Headar/Header";
import History from "./Screens/Dashboard/History/History";
import DoctorNotes from "./Screens/Dashboard/DoctorNotes/DoctorNotes";
import Records from "./Screens/Dashboard/Records/Records";
import DataVisualization from "./Screens/Dashboard/DataVisualization/DataVisualization";
import DentalChart from "./Screens/Dashboard/DentalChart/DentalChart";
import Login from "./Screens/LogIn/Login";
import MedicineGroups from "./Screens/ManageMedicineGroups/MedicineGroups";
import DoctorProfile from "./Screens/Setting/DoctorProfile";
import { AuthProvider, useAuth } from "./AuthProvider";
import { AppProvider } from "./AppProvider";
import RequireAuth from "./RequireAuth";
import RequireRole, { RequireNotStaff } from "./RequireRole";
import SignUp from "./Screens/LogIn/SignUp";
import ForgotPassword from "./Screens/LogIn/ForgotPassword";
import TermsOfUse from "./Screens/LogIn/TermsOfUse";
import Loader from "./Components/GlobalLoader/Loader";
import Clinics from "./Screens/LogIn/Clinics";
import DoctorClinic from "./Screens/Setting/DoctorClinic/DoctorClinic";
import ClinicDetailsCard from "./Screens/Setting/DoctorClinic/ClinicDetailsCard";
import Notification from "./Components/Notification/Notification";
import ClinicPrescription from "./Screens/Setting/ClinicPrescription/ClinicPrescription";
import Overview from "./Screens/Overview/Overview";
import Payments from "./Screens/Payments/Payments";
import SKUManagements from "./Screens/Setting/SKUManagements/SKUManagements";


const Layout = () => {
  const { user, isLoggingIn } = useAuth();
  return (
    <>
      {(user && !isLoggingIn) && <Sidebar />}
      {user && <Header />}
      {user && <Outlet />}
    </>
  );
};

function AppHelper() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    window.addEventListener("beforeunload", () => {
      setLoading(true);
    });

    return () => clearTimeout(timer);
  }, []);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RequireAuth />,
      children: [
        {
          path: "/",
          element: <Layout />,
          children: [
            {
              path: "/",
              element: <Home />
            },
            {
              path: "/DashboardDashboardNavigation",
              element: <RequireNotStaff><DashboardDashboardNavigation /></RequireNotStaff>,
              children: [
                {
                  path: "history",
                  element: <History />
                },
                {
                  index: true,
                  element: <History />
                },
                {
                  path: "doctornotes",
                  element: <DoctorNotes />
                },
                {
                  path: "records",
                  element: <Outlet />,
                  children: [
                    {
                      path: ":recordId",
                      element: <Records />
                    },
                    {
                      index: true,
                      element: <Records />
                    }
                  ]
                },
                {
                  path: "visualization",
                  element: <DataVisualization />
                },
                {
                  path: "dental",
                  element: <RequireRole allowedRoles={['dentist']}><DentalChart /></RequireRole>
                }
              ]
            },
            {
              path: "/calendar",
              element: <Calendar />
            },
            {
              path: "/chat",
              element: <Chat />
            },
            {
              path: "/setting",
              element: <Setting />
            },
            {
              path: "/notification",
              element: <Notification />
            },
            {
              path: "/overview",
              element: <Overview />
            },
            {
              path: "/payments",
              element: <Payments />
            },
            {
              path: "setting/doctorprofile",
              element: <DoctorProfile />
            },
            {
              path: "setting/doctorclinic",
              element: <DoctorClinic />,
            },
            {
              path: "setting/clinicPrescription",
              element: <ClinicPrescription />
            },
            {
              path: "setting/SKUManagements",
              element: <SKUManagements />
            },
            {
              path: "setting/doctorclinic/clinicdetailscard",
              element: <Outlet />,
              children: [
                {
                  path: ":clinicdetailscardId",
                  element: <ClinicDetailsCard />
                },
              ]
            },
            {
              path: "setting/managemedicinegroups",
              element: <Outlet />,
              children: [
                {
                  path: ":MediRecordId",
                  element: <MedicineGroups />
                },
                {
                  index: true,
                  path: "",
                  element: <MedicineGroups />
                }
              ]
            },

          ]
        }
      ]
    },
    {
      path: "/login",
      element: <Login />
    },
    // {
    //   path: "/signUp",
    //   element: <SignUp />
    // },
    {
      path: "/forgotpassword",
      element: <ForgotPassword />
    },
    {
      path: "/terms-of-use",
      element: <TermsOfUse />
    },
    {
      path: "/clinics",
      element: <Clinics />
    },

  ]);

  return (
    <AppProvider>
      <div className="App">
        {loading ? (
          <div className="loader">
            <Loader message="Please Wait" />
          </div>
        ) : (
          <div className="container">
            <RouterProvider router={router}></RouterProvider>
          </div>
        )}
      </div>
    </AppProvider>
  );

}

function App() {



  return (
    <AuthProvider>
      {/* <AppProvider> */}
      <AppHelper />
      {/* </AppProvider> */}
    </AuthProvider>
  );
}

export default App;
